module.exports = __webpack_public_path__ + "img/successful4.0530ede9.png";